import { AppUtils } from '../../shared/utils/index';

 
export namespace Components {
	export function getComponents<T extends BasicAppDefinition>(application: { options: BasicAppOptions<T> },
		callback: (components: { [key: string]: string | HTMLElement }) => void, errorCallback: (jqxhr: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {
		const components: { [key: string]: string | HTMLElement } = {};

		const deferred = $.Deferred();
		let promise = deferred.promise();

		// eslint-disable-next-line prefer-const
		for (let propName in application.options.app.komponentenurls) { //NOSONAR
			promise = promise.then(() => {
				return AppUtils.Ajax.fragment({
					url: application.options.app.komponentenurls[propName],
					dataType: 'html',
					timeout: 30000
				}, (successdata: string) => {
					components[propName] = successdata;
				}, (jqxhr, textStatus, errorThrown) => {
					errorCallback(jqxhr, textStatus, errorThrown);
				});
			});
		}

		promise.done(() => {
			callback(components);
		});

		deferred.resolve();

	}

}
